import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ManageOpenShiftsService } from 'app/modules/manage-shifts/services/manage-open-shifts.service';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { OverlayPanel } from 'primeng';

@Component({
  selector: 'app-manage-shifts-team-day-list',
  templateUrl: './manage-shifts-team-day-list.component.html',
  styleUrls: ['./manage-shifts-team-day-list.component.scss']
})
export class ManageShiftsTeamDayListComponent implements OnInit {
  @Input() searchTeam: any;
  @Input() fromDate: any;
  @Input() selectedAvailability: any;
  @Input() offset: any;
  @Input() isPastDate: any;
  @Input() providerId: any;
  @Input() serviceRegionIds: any;
  @Output() totalCount: EventEmitter<any> = new EventEmitter<any>();
  hasShowPublishShiftPopUp = false;
  isLoaded = false;
  toDate = new Date();
  limit = 10;
  currentOffset = 10;
  teamDetails: any[] = [];
  dayOffset = AppSettings.ONE_DAY_IN_MILISECOND;
  selectedTeam = '';
  selectedDate: any;
  teamShiftsList: any[] = [];
  teamAvailabilityStatusColor = AppSettings.TEAM_AVAILABILITY_STATUS;
  teamShiftStatusColor = AppSettings.TEAM_SHIFT_STATUS;
  bgUnavailable = AppSettings.TEAM_UNAVAILABILITY_STATUS;
  bgCardClass = '';
  borderClass = '';
  @ViewChild('op') op: OverlayPanel;
  sortType = 'asc';
  isOpenShiftPermission = false;
  organizationLevelDispatch = false;
  organizationLevelDispatchFlexible: Boolean = false;
  providerLevelDOO = false;
  providerLevelDutyArr: any = [];
  teamLevelDutyArr: any = [];
  providerLevelDutyArrFlexible: any = [];
  teamLevelDutyArrFlexible: any = [];
  globalConfigOS: any = false;

  constructor(private manageOpenShiftsService: ManageOpenShiftsService, private router: Router,
    private uiService: UiService, private commonService: CommonBindingDataService ) {
  }

  ngOnInit(): void {
    this.isOpenShiftPermission = this.commonService.hasAccessPresent('GET_OPEN_SHIFT_GRID_LIST');
    this.globalConfigOS = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.OPEN_SHIFT)?.value;
    this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)?.forEach(ele => {
      this.providerLevelDutyArr.push(ele.providerId);
    });
    this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL)?.forEach(ele => {
      this.teamLevelDutyArr.push(ele.teamId);
    });
    this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL_FLEX_SHIFT)?.forEach(ele => {
      this.providerLevelDutyArrFlexible.push(ele.providerId);
    });
    this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL_FLEX_SHIFT)?.forEach(ele => {
      this.teamLevelDutyArrFlexible.push(ele.teamId);
    });
    this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
    this.organizationLevelDispatchFlexible = this.commonService.getGlobalConfigByKey(
      AppSettings.GLOBAL_CONFIGRATION.ORGANIZATION_FLEX_SHIFT)?.value;
  }

  ngOnChanges() {
    this.toDate.setTime(this.fromDate.getTime());
    this.getTeamList();
  }


  getTeamList() {
    this.isLoaded = false;
    const formattedFromDate = moment(this.fromDate).format('YYYY/MM/DD');
    const formattedToDate = moment(this.toDate).format('YYYY/MM/DD');
    const formattedStatusId = this.selectedAvailability.length ? this.selectedAvailability : '';
    this.manageOpenShiftsService.getTeamList(formattedFromDate, formattedToDate, this.limit, this.offset,
      this.searchTeam, formattedStatusId, this.sortType, 'day', this.providerId, this.serviceRegionIds).subscribe((teamDetails) => {
      this.isLoaded = true;
      this.totalCount.emit(teamDetails.count);
      if (this.offset > this.currentOffset) {
        this.currentOffset = this.offset;
        const data = teamDetails.data;
        this.teamDetails = [...this.teamDetails, ...data];

      } else {
        this.teamDetails = teamDetails.data;
        this.currentOffset = this.offset;

      }
    },
      (error) => {
        this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
        this.isLoaded = true;
      });
  }

  openShift(teamDetails, id?) {
    this.hasShowPublishShiftPopUp = true;
    this.selectedTeam = id;
    this.selectedDate = teamDetails.dateStr;
    const currentDate = new Date();
    const currentFormattedDate  = moment(currentDate).format('MM/DD/YYYY');
    if (currentFormattedDate === this.selectedDate) {
      currentDate.setTime(currentDate.getTime() + (1 * this.dayOffset));
      this.selectedDate = moment(currentDate).format('MM/DD/YYYY');
    } else {
      this.selectedDate = teamDetails.dateStr;
    }
  }

  goToEdit(date, data) {
    this.router.navigate(['hc-providers/edit-teams'], { queryParams: { id: data.id, providerId: data.providerId }, state: { date } });
  }
  onClickOfPopupButton(event) {
    if (event !== null) {
      this.uiService.showMessage(event.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    }
    this.hasShowPublishShiftPopUp = false;
    this.getTeamList();
  }
  manageTeamShifts(teamShifts) {
    if (teamShifts.length > 2) {
      return teamShifts.slice(0, 2);
    }
    return teamShifts;
  }

  toggleOverviewPanel(event, teamShifts) {
    this.teamShiftsList = teamShifts;
    this.op.toggle(event);
  }

  sortTeams() {
    this.sortType = this.sortType === 'asc' ? 'desc' : 'asc';
    this.offset = 0;
    this.getTeamList();
  }
}


